import api from "@/api"

const state = {
  emails: [],
  selectedEmail: null,
  categories: [],
  studios: [],
  folders: [],
}

const mutations = {
  SET_EMAILS(state, emails) {
    state.emails = emails
  },
  SET_SELECTED_EMAIL(state, email) {
    state.selectedEmail = email
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_STUDIOS(state, studios) {
    state.studios = studios
  },
  SET_FOLDERS(state, folders) {
    state.folders = folders
  },
  UPDATE_EMAIL(state, updatedEmail) {
    const index = state.emails.findIndex((email) => email._id === updatedEmail._id)
    if (index !== -1) {
      state.emails.splice(index, 1, updatedEmail)
      if (state.selectedEmail && state.selectedEmail._id === updatedEmail._id) {
        state.selectedEmail = updatedEmail
      }
    }
  },
  ARCHIVE_EMAIL(state, emailId) {
    state.emails = state.emails.filter((email) => email._id !== emailId)
    if (state.selectedEmail && state.selectedEmail._id === emailId) {
      state.selectedEmail = null
    }
  },
}

const actions = {
  fetchEmails({ commit }) {
    return api.mails
      .getMails()
      .then((response) => {
        commit("SET_EMAILS", response.data)
      })
      .catch((error) => {
        console.error("Error fetching emails:", error)
      })
  },
  selectEmail({ commit }, email) {
    commit("SET_SELECTED_EMAIL", email)
  },
  fetchFolders({ commit }) {
    return api.mails
      .getFolders()
      .then((response) => {
        commit("SET_FOLDERS", response.data)
      })
      .catch((error) => {
        console.error("Error fetching folders:", error)
      })
  },
  syncEmails({ dispatch }) {
    return api.mails.syncEmails().then(() => {
      dispatch("fetchEmails")
    })
  },
  categorizeEmail({ commit }, { emailId, category, studioId }) {
    return api.mails.categorizeEmail(emailId, category, studioId).then((response) => {
      commit("UPDATE_EMAIL", response.data)
    })
  },
  fetchStudios({ commit }) {
    // This is a placeholder. You need to implement the API endpoint to fetch studios.
    const studios = [
      { _id: "1", name: "Studio 1" },
      { _id: "2", name: "Studio 2" },
    ]
    commit("SET_STUDIOS", studios)
  },
  fetchCategories({ commit }) {
    // This is a placeholder. You need to implement the API endpoint to fetch categories.
    const categories = ["General", "Support", "Sales"]
    commit("SET_CATEGORIES", categories)
  },
  sendEmail({ commit }, { to, subject, text, replyTo }) {
    return api.mails.sendEmail(to, subject, text, replyTo).then(() => {
      if (replyTo) {
        commit("ARCHIVE_EMAIL", replyTo)
      }
    })
  },
}

const getters = {
  emails: (state) => state.emails,
  selectedEmail: (state) => state.selectedEmail,
  categories: (state) => state.categories,
  studios: (state) => state.studios,
  folders: (state) => state.folders,
}

export const mailStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
